import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { profileContainer } from '../../di/container';
import { useAuthStore } from '../../../auth/presentation/store/auth.store';
import type { UpdateProfileInput } from '../../domain/entities/profile.entity';

/** Chave única do usuário corrente — o back o resolve pelo token, não por id. */
const ME_QUERY_KEY = ['profile', 'me'] as const;

export function useProfile() {
  const { auth } = useAuthStore();

  return useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: () => profileContainer.repository.getMe(),
    enabled: !!auth,
    retry: false,
  });
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateProfileInput) =>
      profileContainer.repository.updateMe(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ME_QUERY_KEY });
    },
  });
}
